module.exports = __webpack_public_path__ + "static/m1-073358fcc45ab613b2cc35b290502b1d.png";